<template>
  <div>
    <div class="layout-page-header">
      <PageHeader title="折扣编辑" hidden-breadcrumb />
    </div>
    <Card :bordered="false" dis-hover class="ivu-mt" ref="card">
      <o-filter ref="filter" @on-submit="handleGetData" />
      <o-table ref="table" @on-fullscreen="handleFullscreen" />
    </Card>
  </div>
</template>
<script>
import screenfull from 'screenfull'
import oTable from './table'
import oFilter from './filter'

export default {
  name: 'vipCard-details',
  components: {
    oFilter,
    oTable,
  },
  data() {
    return {}
  },
  methods: {
    handleGetData() {
      this.$refs.table.handleGetDataList()
    },
    handleFullscreen(state) {
      if (state) {
        screenfull.request(this.$refs.card.$el)
      } else {
        screenfull.exit()
      }
    },
  },
  mounted() {
    this.handleGetData()
  },
}
</script>
